import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../config";
import { useEffect, useState } from "react";

const API_URL = config.baseUrl;

export const getVisaApplications = createAsyncThunk(
  "visa/getVisaApplications",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(`${API_URL}/tourist-visa`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Failed to fetch visa list");
    }
  },
);

const visaSlice = createSlice({
  name: "visa",
  initialState: {
    isLoading: false,
    list: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVisaApplications.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVisaApplications.fulfilled, (state, action) => {
        state.list = action.payload;
        state.isLoading = false;
      })
      .addCase(getVisaApplications.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default visaSlice.reducer;

